var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPath66(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0044 57.1055H19.4943L0.810059 24.7695C0.810059 24.7321 0.810063 24.6963 0.881706 24.6605C5.57108 16.478 12.0271 9.44778 19.7109 4.04163C21.261 2.92363 22.8469 1.91302 24.5077 0.97728L38.2486 24.6963L40.774 29.0593L57.0044 57.1055Z",
    fill: "#2358A4",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.173 26.1827C113.886 25.6782 113.561 25.138 113.272 24.6693C113.272 24.7051 113.272 24.7051 113.272 24.6693C107.609 14.8285 99.3851 6.60866 89.539 0.912842L75.7965 24.6693L73.2711 28.9948C77.9979 31.7353 82.0018 35.628 84.8138 40.3149C85.102 40.7461 85.3544 41.179 85.6068 41.6477C88.1322 46.2629 89.539 51.4884 89.539 57.1143C89.539 69.1536 83.0113 79.6436 73.2711 85.2304C68.5101 87.9709 62.8828 89.5576 57.0048 89.5576C51.0893 89.5576 45.5354 87.9351 40.7743 85.1588L38.2489 89.5576L24.5081 113.241C34.0659 118.793 45.2472 121.965 57.0781 122.001C68.909 122.001 79.9795 118.865 89.539 113.314C99.3851 107.618 107.645 99.3626 113.308 89.5218C113.596 89.0515 113.886 88.547 114.173 88.0425C119.15 78.8511 122 68.3236 122 57.1143C122 45.9016 119.15 35.3758 114.173 26.1827Z",
    fill: "#2358A4",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath66);
export default __webpack_public_path__ + "static/media/path66.2b64a935bf95a07120e6821e2e6b9b9e.svg";
export { ForwardRef as ReactComponent };